import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { DoctoralCommitteeCard } from './components/Card/DoctoralCommitteeCard';
import { getDoctoralCommitteePagedOptions } from './model/DoctoralCommitteeQuery';

export function DoctoralCommitteeBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getDoctoralCommitteePagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('doctoralCommittees.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('doctoralCommittees.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('doctoralCommittees.sortedByEndDate')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={doctoralCommittee => (
        <DoctoralCommitteeCard
          key={doctoralCommittee.id}
          doctoralCommittee={doctoralCommittee}
          to={`${doctoralCommittee.id}`}
        />
      )}
    />
  );
}
